module.exports = "https://static.energy5.com/_next/static/images/smallDecor-4159cb564d8cdceeef9a6ef6d718516b.png";